export default class Lens {
    public lensId: number;
    public name: string;
    public slug: string;

    constructor(init?: Partial<Lens>) {
        Object.assign(this, init);
    }
}
